import React from 'react'
import './index.less'
import dayjs from "dayjs";
import Lang from "@components/Lang/Lang";

class OrderInfo extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {info} = this.props
        return (
            <div className="cancelRecord-orderInfo lineH_20 ">
                <div className="mb_12" data-flex="cross:center">
                    <p className="details-info font-title fw_500 font_14 mr_28">
                            <span className="mr_8">
                                {__getServerLanguage('DingDan')} {info.contactOrder} 【{info.status}】
                            </span>
                        <span className="con2-txt font_12">{info.createTime?dayjs(info.createTime).format("YYYY-MM-DD HH:mm:ss"):'-'}</span>
                    </p>

                    <p className="details-info font-title fw_500 font_14">
                            <span className="mr_8">
                                {__getServerLanguage('KeHuBianHao')}
                            </span>
                        <span className="con2-txt font_12">
                                <i className="font-title mr_6">{info.buyerNumber}</i>
                                <i>{info.email}</i>
                            </span>
                    </p>
                </div>
                <p className="details-info font-title fw_500 font_14">
                            <span className="mr_8">
                                {__getServerLanguage('ShouHuoRen')}
                            </span>
                    <span className="con2-txt font_12">
                                <i className="font-title mr_8">{info.consignee}</i>
                                <i>{info.address}</i>
                            </span>
                </p>
                <p className="details-info font-title fw_500 font_14 mt_12">
                            <span className="mr_8">
                                {Lang({id:"DangQianCangKu",default:"当前仓库"})}
                            </span>
                            <span className="black89">
                              {info.transitCityName}
                            </span>
                </p>
            </div>
        )
    }
}

OrderInfo.defaultProps = {
    info: {}
}

export default OrderInfo
